module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/resources-dietary-info-anti-reflux-diet.json
// module id = 438
// module chunks = 255617574101689